import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { FiHome, FiMessageCircle, FiClock, FiHelpCircle, FiUser, FiLogOut } from 'react-icons/fi';
import NotificationBell from '../NotificationBell';
import api from '../../utils/api';

const navItems = [
  { path: '/user/dashboard', label: 'Overview', icon: <FiHome /> },
  { path: '/user/campaigns', label: 'My Broadcasts', icon: <FiMessageCircle /> },
  { path: '/user/activity', label: 'Activity', icon: <FiClock /> },
  { path: '/user/help', label: 'Help Center', icon: <FiHelpCircle /> },
  { path: '/user/profile', label: 'Account', icon: <FiUser /> },
];

const PAGE_TITLES = {
  '/user/dashboard': 'Overview',
  '/user/campaigns': 'My Broadcasts',
  '/user/activity': 'Activity',
  '/user/help': 'Help Center',
  '/user/profile': 'My Account',
};

export default function UserLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    api.get('/auth/branding').then(({ data }) => setBranding(data)).catch(() => {});
  }, []);

  const getPageTitle = () => {
    const path = location.pathname;
    if (PAGE_TITLES[path]) return PAGE_TITLES[path];
    if (path.includes('/user/campaigns/') && path.includes('/batch/')) return 'Batch View';
    if (path.includes('/user/campaigns/')) return 'Campaign Details';
    return 'User Dashboard';
  };

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src={branding?.logoUrl || '/Affixcenter_OG_Fulllogo.png'} alt="Logo" className="sidebar-logo-img" style={{ width: 38, height: 38, borderRadius: 8, objectFit: 'contain' , background:'white'}} />
          <div className="sidebar-logo-text">
            <h1>{branding?.appName || 'Affix Digital Setu'}</h1>
            <span>{branding?.panelLabels?.user || 'User Panel'}</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section">
            <div className="sidebar-section-title">Navigation</div>
            {navItems.map(item => (
              <NavLink key={item.path} to={item.path} data-tooltip={item.label}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
                {item.icon}
                <span className="link-label">{item.label}</span>
              </NavLink>
            ))}
          </div>
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="sidebar-link" data-tooltip="Logout" style={{ width: '100%', border: 'none', background: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
            <FiLogOut />
            <span className="link-label">Logout</span>
          </button>
        </div>
      </aside>

      <header className="header">
        <h2 className="header-title">{getPageTitle()}</h2>
        <div className="header-actions">
          <NotificationBell role="user" />
          <div className="header-user" onClick={() => navigate('/user/profile')}>
            <div className="header-avatar">{user?.username?.[0]?.toUpperCase()}</div>
            <div className="header-user-info">
              <span>{user?.username}</span>
              <small>{user?.role}</small>
            </div>
          </div>
        </div>
      </header>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
